/* «Por procesar» → «Por Procesar»: los estados en etiquetas y chips van en Title Case (el servidor manda el nombre en minúsculas). */
const MENORES = ["de", "del", "la", "las", "el", "los", "y", "o", "a", "en", "por", "con"];

export const tituloEstado = (s: string | null | undefined): string =>
	String(s || "").split(" ").map((w, i) => (i > 0 && MENORES.includes(w.toLowerCase()) && i !== 0 ? w : w.charAt(0).toUpperCase() + w.slice(1))).join(" ")
		.replace(/^(\S+)/, (w) => w.charAt(0).toUpperCase() + w.slice(1));

export default tituloEstado;
